<template>
  <div class="allRankPage">
    <van-tabs v-model="activeList" class="rankingChildTabs">
      <van-tab title="个人榜" name="person"> </van-tab>
      <van-tab title="政区榜" name="administrative"> </van-tab>
      <van-tab title="责任榜" name="duty"> </van-tab>
    </van-tabs>
    <van-tabs v-model="activeTime" class="timeTabs ggTabs" type="card">
      <van-tab title="日" name="rankingDay"></van-tab>
      <van-tab title="月" name="rankingMonth"></van-tab>
      <van-tab title="年" name="rankingYear"></van-tab>
    </van-tabs>
    <div class="TabsList">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
      >
        <div
          v-for="(item, index) in baselist"
          :key="item.id"
          class="itemList clear"
        >
          <p class="fl tit clear">
            <span v-if="parseFloat(index) < 3"
              ><img
                :src="baseUrl + 'xunlinOne.png'"
                alt=""
                v-if="index == '0'" />
              <img
                :src="baseUrl + 'xunlinTwo.png'"
                alt=""
                v-if="index == '1'" />
              <img
                :src="baseUrl + 'xunlinThree.png'"
                alt=""
                v-if="index == '2'"
            /></span>
            <span v-else class="spanText">{{ index + 1 }}</span>
          </p>
          <div v-if="activeList == 'person'" class="fl ggListMain">
            <dl class="dlBox">
              <dt>
                <van-image
                  :src="item.avatar ? item.avatar : baseUrl + 'userDefault.png'"
                />
              </dt>
              <dd class="ddMain">
                <span
                  ><em>{{ item.realName }}</em>
                  <van-tag type="warning">{{ item.postName }}</van-tag>
                </span>
                <span class="lastSpan">{{ item.orgName }}</span>
              </dd>
            </dl>
          </div>
          <div v-if="activeList == 'administrative'" class="fl ggListMain">
            <p class="pName">{{ item.zqName ? item.zqName : "暂无" }}</p>
          </div>
          <div v-if="activeList == 'duty'" class="fl ggListMain">
            <p class="pName">{{ item.gridName }}</p>
          </div>
          <span class="itemPoints fr"
            >{{
              activeList == "person"
                ? item.forestNumbers
                : activeList == "administrative"
                ? item.forestNumber
                : item.forestNumber
            }}次</span
          >
        </div>
      </van-list>
      <div class="emptypage" v-if="noneRankListType">
        <van-image :src="baseUrl + 'empty.png'" />
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/

import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "allXunLRank",
  components: {},
  data() {
    return {
      activeList: "",
      activeTime: "",
      clientType: getDeviceType(), //手机类型
      baseUrl: process.env.BASE_URL,

      baselist: [],
      sourceList: [],
      loading: true,
      finished: false,
      pageNum: 0,
      pageSize: 99,
      total: "",
      finishedText: "",
      noneRankListType: false,
      loadType: true,
    };
  },
  mounted() {
    document.title = "巡林排行榜";
    this.activeList = this.$route.query.activeList
      ? this.$route.query.activeList
      : "person";
    this.activeTime = this.$route.query.rankingTypeActive
      ? this.$route.query.rankingTypeActive
      : "rankingDay";
    let type = "";
    type =
      this.activeTime == "rankingDay"
        ? 0
        : this.activeTime == "rankingMonth"
        ? 1
        : 2;

    this.getRankingList(type, this.activeList);
  },
  methods: {
    getRankingList(type, mode) {
      let _this = this;
      _this.loading = true;
      _this.finished = false;
      if (
        _this.pageNum != 0 &&
        _this.pageNum * _this.pageSize >= parseInt(_this.total)
      ) {
        return;
      }
      _this.pageNum += 1;
      if (_this.loadType) {
        //防止多次加载
        _this.loadType = false;
        _this.$api.xunLData
          .getXunLRank(_this.pageNum, _this.pageSize, type, mode)
          .then((res) => {
            if (res.code == "1" && res.data.list[0]) {
              _this.total = parseInt(res.data.total);
              _this.sourceList = res.data.list;
              _this.viewLists();
              // 加载状态结束
              _this.loading = false;
              if (_this.pageNum * _this.pageSize >= _this.total) {
                _this.finished = true;
              } else {
                _this.getRankingList(type, mode);
              }
              _this.finishedText = "没有更多了";
              _this.loadType = true;
            } else {
              _this.loading = false;
              _this.finished = true;
              _this.noneRankListType = true;
              _this.loadType = true;
            }
          })
          .catch((err) => {
            _this.loading = false;
            _this.finished = true;
            _this.noneRankListType = true;
            _this.loadType = true;
            console.log(err);
          });
      }
    },
    viewLists() {
      let _this = this;
      _this.baselist = _this.baselist.concat(this.sourceList);

      _this.baselist[0]
        ? (_this.noneRankListType = false)
        : (_this.noneRankListType = true);
    },

    getRoladPage(time, active) {
      this.baselist = [];
      this.pageNum = 0;
      this.total = 0;
      let type = time == "rankingDay" ? 0 : time == "rankingMonth" ? 1 : 2;
      this.getRankingList(type, active);
    },
  },
  watch: {
    activeTime(newValue) {
      if ((newValue, this.activeList)) {
        this.getRoladPage(newValue, this.activeList);
      }
    },
    activeList(newMode) {
      if (newMode && this.activeTime) {
        this.getRoladPage(this.activeTime, newMode);
      }
    },
  },
};
</script>
<style lang="less">
.allRankPage {
  width: 100%;
  height: 100%;
  position: relative;
  font-family: "PingFangSC-Medium", "PingFang SC";
  .rankingChildTabs {
    .van-tabs__nav {
      background-color: #eafff0;
    }
    .van-tab {
      font-size: 16px;
      font-weight: 500;
      color: #92daa8;
    }
    .van-tab.van-tab--active {
      color: #58c278;
    }
    .van-tabs__line {
      background-color: #58c278;
      width: 25px;
    }
  }
  .timeTabs {
    margin-top: 12px;
    .van-tabs__nav {
      width: 185px;
      height: 30px;
      margin: 0 auto;
      border-radius: 15px;
      background-color: #eafff0;
      border: 1px solid #b6eac5;
      .van-tab {
        border-radius: 15px;
        color: #58c278;
        font-size: 14px;
        border-right: 0 none;
      }
      .van-tab.van-tab--active {
        background-color: #58c278;
        color: #fff;
      }
    }
  }
  .van-tabs__wrap.van-hairline--top-bottom::after {
    content: none;
  }
  .TabsList {
    width: 100%;
    margin-top: 10px;
    padding: 0 16px;
    height: calc(100% - 100px);
    padding-bottom: 30px;
    overflow-y: scroll;
    position: relative;
    .itemList {
      width: 100%;
      height: 45px;
      margin: 15px 0;
      font-family: "PingFangSC-Regular", "PingFang SC";
      p.tit {
        display: inline-block;
        span {
          display: block;
          width: 25px;
          height: 45px;
          line-height: 45px;
          text-align: center;
          padding-top: 7px;
          img {
            height: 32px;
          }
        }
        .spanText {
          font-size: 16px;
          font-weight: 500;
          color: #abb2ba;
        }
      }
      .ggListMain {
        margin-left: 30px;
        width: 60%;
        .dlBox {
          dt {
            display: inline-block;
            width: 45px;
            height: 45px;
            .van-image {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }
          .ddMain {
            width: calc(100% - 55px);
            display: inline-block;
            margin-left: 10px;
            > span {
              width: 100%;
              display: block;
              font-size: 12px;
              color: #8b8b8b;
              line-height: 17px;
              position: relative;
              em {
                display: inline-block;
                font-size: 16px;
                color: #333;
                line-height: 22px;
                font-weight: 400;
              }
              .van-tag {
                margin-left: 8px;
                display: inline-block;
                padding: 2px 6px;
                line-height: 16px;
                font-size: 12px;
                background-color: #ffa70a;
                vertical-align: top;
              }
            }
            .lastSpan {
              margin-top: 5px;
            }
          }
        }
        .pName {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          line-height: 45px;
        }
      }
      .itemPoints {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 45px;
      }
    }
    .emptypage {
      width: 116px;
      height: 125px;
      position: absolute;
      top: 25%;
      left: 50%;
      margin-left: -58px;
    }
  }
}
</style>